import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function BookCTA() {
  const { lang } = useLang();
  return (
    <section className="py-12 md:py-16 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto rounded-3xl overflow-hidden shadow-2xl relative bg-gradient-to-r from-nv-orange via-nv-orange-deep to-nv-orange">
        <div className="absolute inset-0 opacity-[0.12] pointer-events-none" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Ctext x='0' y='55' font-size='55' fill='%23FFFFFF'%3Eॐ%3C/text%3E%3C/svg%3E")`
        }} />
        <div className="relative grid md:grid-cols-2 gap-4 p-8 md:p-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-white/20 text-white px-3 py-1 rounded-full text-xs mb-3">
              <Sparkles className="w-3 h-3" /> {lang === 'en' ? 'Special Offer' : 'विशेष अवसर'}
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-2">
              {lang === 'en' ? 'Book Puja now, receive the true experience of faith' : 'अभी पूजा बुक करें और पाएं आस्था का सच्चा अनुभव'}
            </h2>
            <p className="text-white/85 text-sm md:text-base">
              {lang === 'en'
                ? 'Easy Booking • Secure Payment • Satisfied Service'
                : 'आसान बुकिंग • सुरक्षित भुगतान • संतुष्ट सेवा'}
            </p>
          </div>
          <div className="flex md:justify-end">
            <Link to="/upcoming-pujas" className="inline-flex items-center gap-2 bg-white text-nv-orange-deep hover:bg-nv-cream font-bold px-7 py-4 rounded-full shadow-xl transition text-sm md:text-base">
              {lang === 'en' ? 'Book Puja Now' : 'अभी पूजा बुक करें'} <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
